<div class="ch-popover" #popover (click)="onPopoverClick()">
  <div class="ch-popover__header">
    <span>{{data.header.title}}</span>
  </div>
  <div class="ch-popover__content">
    <span>{{data.content}}</span>
  </div>
  <div class="ch-popover__footer">
    @for (item of data.footer; track item) {
      @switch (item.type) {
        @case ('button') {
          <button
            (click)="item.event.action()"
            [ngClass]="item.classNames"
            >
            {{item.content}}
          </button>
        }
      }
    }
  </div>
</div>
